import messageResource from "./messageResource"
import _ from "underscore"
import View from "./View"

export default class PageMediator extends View {

    constructor() {
        super()
    }

    getPage() {
        // Abstract
    }

    openPage() {
        if (!this._openedPageBefore) {
            this.beforeOpenPageFirstTime();
            this._openedPageBefore = true;
        }
        this.beforeOpenPage();

        this.getPage().show();
        this.getPage().$el.atAnimation().fadeIn();
    }

    leavePage() {
        if (this._openedPageBefore) {
            this.beforeLeavePage();
            this.getPage().hide();
            this.getPage().$el.atAnimation().fadeOut();
        }
    }

    beforeOpenPageFirstTime() {
        // Abstract
    }

    beforeOpenPage() {
        // Abstract
    }

    beforeLeavePage() {
        // Abstract
    }

    showAlertAndReloadPage(msgKey) {
        alert(messageResource.getMessage(msgKey));
        window.location.reload();
        return true;
    }

    abortRpcCall(rpc) {
        if (!_.isUndefined(rpc)) {
            rpc.abort();
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/PageMediator.js